import clsx from 'clsx'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { v4 } from 'uuid'

import { MilestoneList } from './components/milestone-list/milestone-list'
import { SubcontractorParams } from './components/subcontractor-params/subcontractor-params'
import styles from './milestone-transfer.page.module.scss'
import { SubcontractorFormValues } from './types/milestone-transfer.types'
import { useGetObjects } from '../../../entities/objects/hooks/object.hooks'
import { useGetUserWorkflows, useTransferMilestone } from '../../../entities/workflow/hooks/workflow.hooks'
import { MilestoneTransferDto } from '../../../entities/workflow/types/workflow.types'
import { ObjectTree } from '../../shared/components/object-tree/object-tree'

export const MilestoneTransferPage = () => {
  const { t } = useTranslation()
  const { data: objects } = useGetObjects()
  const { data: milestones } = useGetUserWorkflows()
  const { mutateAsync: transferMilestone } = useTransferMilestone()

  const [key, setKey] = useState<string>('')
  const [selectedObjects, setSelectedObjects] = useState<number[]>([])
  const [selectedMilestones, setSelectedMilestones] = useState<number[]>([])

  const handleObjectsCheck = (objectIds: number[]) => {
    setSelectedObjects(objectIds)
  }

  const handleMilestoneCheck = (milestoneIds: number[]) => {
    setSelectedMilestones(milestoneIds)
  }

  const handleSubcontractorSubmit = async (values: SubcontractorFormValues) => {
    if (!selectedMilestones.length) {
      toast.error('Необходимо выбрать хотя бы один майлстоун')

      return
    }
    if (!selectedObjects.length) {
      toast.error('Необходимо выбрать хотя бы один объект')

      return
    }
    const data: MilestoneTransferDto = {
      ...values,
      objects: selectedObjects,
      milestones: selectedMilestones,
    }

    try {
      await transferMilestone(data)
      toast.success('Передача успешна')
      setKey(v4())
    } catch {
      toast.error('Передача неудачна')
    }
  }

  return (
    <div key={key}>
      <div>
        <h1>{t('milestoneTransfer.header')}</h1>
      </div>
      <div className={clsx('d-flex w-100', styles.milestoneTransferPage)}>
        <div className={clsx('col-3', styles.milestoneTransferPageColumn)}>
          <SubcontractorParams onSubmit={handleSubcontractorSubmit} />
        </div>
        <div className={clsx('col-6', styles.milestoneTransferPageColumn)}>
          {milestones ? (
            <MilestoneList
              milestones={milestones}
              onCheck={handleMilestoneCheck}
            />
          ) : null}
        </div>
        <div className={clsx('col-3', styles.milestoneTransferPageColumn, styles.objectTreeWrap)}>
          {objects ? (
            <ObjectTree
              objects={objects}
              onCheck={handleObjectsCheck}
            />
          ) : null}
        </div>
      </div>
    </div>
  )
}
